import * as React from 'react'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { IconShoppingCartDL } from '../Icons'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'

const AnimatedCartIcon = ({ onMouseEnter, onMouseLeave }) => {
  const cartLength = useSelector(state => state.cart.products.length)

  const [playAnimation, setPlayAnimation] = useState(null)
  useEffect(() => {
    if (!cartLength) return
    setPlayAnimation(p => p !== null)
    const timeout = setTimeout(() => {
      setPlayAnimation(false)
    }, 4000)
    return () => clearTimeout(timeout)
  }, [cartLength])
  const LinkComponent = cartLength ? Link : 'a'
  const LinkProps = cartLength
    ? {
        to: '/checkout',
        onMouseEnter,
        onMouseLeave,
      }
    : {
        href: '#',
        title: 'Your cart is empty',
      }

  return (
    <>
      <div
        className={
          'pointer-events-none h-2 w-2 bg-red-700 font-bold text-white absolute ' +
          (playAnimation ? ' item-cart-animation' : ' item-cart-stopped') +
          (cartLength ? '' : ' hidden')
        }
      >
        <p>
          {cartLength < 10 ? (
            cartLength
          ) : (
            <span className={'relative left-[0.038rem] text-[.35rem]'}>
              9<sup className={'relative top-[-0.03rem]'}>+</sup>
            </span>
          )}
        </p>
      </div>
      <LinkComponent
        {...LinkProps}
        className={'block' + (cartLength === 0 ? ' text-gray-300 cursor-not-allowed' : '')}
      >
        <span className="sr-only">View Cart</span>
        <IconShoppingCartDL
          playAnimation={playAnimation && cartLength === 1}
          cartCargoClass={cartLength ? 'cart-cargo-stopped' : 'cart-cargo-empty'}
        />
      </LinkComponent>
    </>
  )
}

AnimatedCartIcon.propTypes = {
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
}

export default AnimatedCartIcon
